/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import {
	queryOptions,
	useQuery,
} from '@tanstack/react-query';

// Types
import { TParamsGetApi } from '@global-types/index';

// Lib
import { apiClient } from '@lib/api-client';

// Constants
import { queryKeys } from '@config/constants/query-keys';
import { TBrand } from '@global-types/api/api';
import { QueryConfig } from '@lib/react-query';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const getBrands = (
	params: Partial<TParamsGetApi>
): Promise<TApiResponseGetBrands> => {
	return apiClient.get('/brands', {
		params,
	});
};

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */

type TApiResponseGetBrands = {
	total: number;
	page: number;
	pageSize: number;
	totalPages: number;
	rows: TBrand[];
};

type TUseGetBrandsOptions = {
	params: Partial<TParamsGetApi>;
	queryConfig?: QueryConfig<typeof getBrands>;
};

/* -------------------------------------------------------------------------- */
/*                                    Helper                                  */
/* -------------------------------------------------------------------------- */
export const getBrandsQueryOptions = (
	params: Partial<TParamsGetApi> = {}
) => {
	return queryOptions({
		queryKey: params
			? [queryKeys.app.brands.all.key, { params }]
			: [queryKeys.app.brands.all.key],
		queryFn: () => getBrands(params),
	});
};

/* -------------------------------------------------------------------------- */
/*                                     Hook                                   */
/* -------------------------------------------------------------------------- */
export const useGetBrands = ({
	params,
	queryConfig,
}: TUseGetBrandsOptions) => {
	return useQuery({
		...getBrandsQueryOptions(params),
		...queryConfig,
	});
};
